import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";

export const postTestimonial = async (form) => {
    try {
        const {
            name, designation, image, rating, comment, id, isFeatured, order
        } = form;

        const formData = new FormData();

        if (id)
            formData.append("id", id);
        formData.append("name", name);
        formData.append("rating", rating);
        formData.append("comment", comment);
        formData.append("designation", designation);
        formData.append("isFeatured", isFeatured);
        formData.append("order", order);

        if (image) {
            if (typeof image === "string") {
                formData.append("image", image);
            }
            else {
                formData.append("pictures", image);
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/testimonial/register`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getTestimonial = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const res = await axiosInstance.get(`/testimonial/all?${params.toString()}`)
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const getTestimonialByID = async (id) => {

    try {
        const res = await axiosInstance.get(`/testimonial/${id}`)
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const deleteTestimonial = async (id) => {
    try {
        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/testimonial/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const postTestimonialdata = async (form) => {
    try {

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(`/home/testimonial`, form, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully resgistered!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const getTotalTestimonial = async () => {
    try {
        const res = await axiosInstance.get(`/testimonial/total`)
        // toast.success("Successfully fetched!");
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}